import { createContext, createElement, useContext, useRef } from "react";
import { StateError } from "../error/StateError.js";
/**
 * Create a cache context that can be provided to React elements and allows them to call `useCache()`
 * - Cache is a `Map` indexed by strings that can be used to store any value.
 */
export function createCacheContext() {
    const context = createContext(undefined);
    return {
        useCache() {
            const cache = useContext(context);
            if (!cache)
                throw new StateError("useCache() must be used inside <Cache>");
            return cache;
        },
        CacheContext({ children }) {
            const cache = (useRef().current ||= new Map());
            return createElement(context.Provider, { children, value: cache });
        },
    };
}
